import App from './App.vue'
import Vue from 'vue'
import global from '../global.scss'
import vuetify from './plugins/vuetify'
import 'core-js'
import 'url-search-params-polyfill'
import store from './store/index'
import i18n, {loadLanguageAsync} from './plugins/i18n.js'

// if browser is compatible, remove the div displaying the error message
// note: document.getElementById("not-compatible-browser").remove() does not work for Internet Explorer 11
document.getElementById('not-compatible-browser').outerHTML = ''

Vue.config.productionTip = process.env.NODE_ENV !== 'production'

// i18n gets lang value from store
loadLanguageAsync(store.state.lang)
store.subscribe(mutation => {
    if (mutation.type === 'setLang') {
        loadLanguageAsync(mutation.payload)
    }
})

new Vue({
    vuetify,
    store,
    i18n,
    global,
    render: h => h(App),

}).$mount('#app')